import { css } from 'lit';

export const forms = css`
  .form-field {
    position: relative;
    text-align: left;
  }

  .not-a-checkbox-mb {
    margin-bottom: 24px;
  }

  .grv-radio-label,
  .grv-checkbox-label {
    color: #141414;
    font-size: 16px;
  }

  .grv-helper-checkbox {
    padding-left: 40px;
  }

  .grv-radio {
    box-sizing: border-box;
    left: 6px;
    margin: 0;
    opacity: 1;
    padding: 0;
    position: absolute;
    top: 6px;
  }

  .grv-radio:focus {
    outline: -webkit-focus-ring-color auto 1px;
    outline-offset: -3px;
  }

  .grv-radio:hover + .grv-radio-label::before,
  .grv-radio:focus + .grv-radio-label::before {
    border: 2px solid #255f82;
  }

  .grv-radio:checked + .grv-radio-label::before {
    border: 8px solid #255f82;
  }

  .grv-radio:checked:hover + .grv-radio-label::before,
  .grv-radio:checked:focus + .grv-radio-label::before {
    border-color: #10253f;
  }

  .grv-radio + .grv-radio-label {
    display: inline-block;
    line-height: 24px;
    padding-left: 40px;
    position: relative;
  }

  .grv-radio + .grv-radio-label::before,
  .grv-radio + .grv-radio-label::after {
    content: '';
    display: inline-block;
    height: 24px;
    left: 0;
    position: absolute;
    top: 0;
    width: 24px;
  }

  .grv-radio + .grv-radio-label::before {
    background: #fff;
    border: 1px solid #696969;
    border-radius: 50%;
    box-sizing: border-box;
    margin-right: 16px;
  }

  .grv-radio-helper,
  .grv-helper {
    color: #141414;
    display: block;
    font-size: 12px;
    margin-top: 8px;
  }

  .grv-radio-helper {
    padding-left: 40px;
  }

  .grv-helper.error {
    color: #cc2427;
  }

  .grv-label {
    color: #141414;
    display: block;
    font-size: 14px;
    padding-bottom: 8px;
  }

  .grv-input {
    -webkit-appearance: none;
    background: #fff;
    border: 0;
    border-radius: 4px;
    box-shadow: inset 0 0 0 1px #696969;
    box-sizing: border-box;
    color: #141414;
    display: block;
    font-family: Optimist, 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    min-height: 48px;
    padding: 0 16px;
    width: 100%;
  }

  .grv-input.error {
    box-shadow: inset 0 0 0 2px #cc2427;
  }

  .grv-input:hover,
  .grv-input:focus {
    box-shadow: inset 0 0 0 2px #255f82;
    outline: none;
  }

  .grv-input::-webkit-input-placeholder,
  .grv-input:-moz-placeholder,
  .grv-input::-moz-placeholder,
  .grv-input:-ms-input-placeholder {
    color: #7d7d7d;
  }

  .grv-input:disabled,
  .grv-input:disabled:hover {
    background-color: #f4f4f4;
    border: 1px solid #d4d4d4;
    box-shadow: none;
    color: #7d7d7d;
    cursor: not-allowed;
  }

  .grv-input:disabled::placeholder,
  .grv-input:disabled:hover::placeholder,
  .grv-input:disabled::-webkit-input-placeholder,
  .grv-input:disabled:hover::-webkit-input-placeholder,
  .grv-input:disabled:-moz-placeholder,
  .grv-input:disabled:hover:-moz-placeholder,
  .grv-input:disabled::-moz-placeholder,
  .grv-input:disabled:hover::-moz-placeholder,
  .grv-input:disabled:-ms-input-placeholder,
  .grv-input:disabled:hover:-ms-input-placeholder {
    color: #7d7d7d;
  }

  .input-flexbox {
    display: flex;
    flex-flow: row;
  }
`;
